import React from 'react';
import './header.css';

const Header = () => {
  return (
      <>
          <div className="br-header-container">
              <div className="br-header">
                    <h1>BRIO ANIMATION STUDIOS</h1>
              </div>
          </div>
      </>
  )
}

export default Header